import { render } from "./conferenceDetails.vue?vue&type=template&id=0f9799fe"
import script from "./conferenceDetails.vue?vue&type=script&lang=js"
export * from "./conferenceDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__